import { languages } from 'utils/constants/languages';

export const getLanguageFlag = (languageCode: string): string => {
  const language = languages[languageCode];
  if (!language) {
    return '';
  }
  return language.flag;
};
